export const sortByKeyAsc = <T>(array: T[], key: keyof T): T[] => {
  return array.sort((a, b) => (a[key] > b[key] ? 1 : -1));
};

export const sortByKeyDesc = <T>(array: T[], key: keyof T): T[] => {
  return array.sort((a, b) => (a[key] < b[key] ? 1 : -1));
};

export const aggregateByKey = <T>(
  array: T[],
  getKey: (item: T) => string,
  getValue: (item: T) => any
): Record<string, any> =>
  array.reduce((acc, item) => {
    const key = getKey(item);
    acc[key] = (acc[key] || 0) + getValue(item);
    return acc;
  }, {} as Record<string, number>);

export const extractDiffMap = (from: Map<any, any>, to: Map<any, any>) => {
  const res = new Map();
  const entries = to.entries();
  entries.forEach((element) => {
    const key = element[0];
    const f = from.get(key);
    const t = to.get(key);
    if (f !== t) {
      res.set(key, to.get(key));
    }
  });

  return res;
};
